import { InjectionToken, type ValueProvider } from '@angular/core';
import { type EnvironmentHost, environments, type EnvironmentSettings, isValidEnvironmentHost } from './environments';

export const ENVIRONMENT_SETTINGS = new InjectionToken<EnvironmentSettings>('ENVIRONMENT_SETTINGS', {
  factory: getEnvironmentSettings,
});

export function provideEnvironment(host?: EnvironmentHost): ValueProvider {
  return {
    provide: ENVIRONMENT_SETTINGS,
    useValue: getEnvironmentSettings(host),
  };
}

function getEnvironmentSettings(host?: EnvironmentHost) {
  if (!host) {
    if (!isValidEnvironmentHost(window.location.host)) {
      throw new Error(`Invalid environment: ${window.location.host}`);
    }

    host = window.location.host;
  }

  return environments[host];
}
